import { z } from "zod";
export const UserSessionEventAction = {
    avtLaunchDictation: "avtLaunchDictation",
    avtAbandonDictation: "avtAbandonDictation",
    avtDiscardNote: "avtDiscardNote",
    avtUseAiNote: "avtUseAiNote",
    avtUseTranscript: "avtUseTranscript",
    avtPasteNote: "avtPasteNote",
};
export const RecordUserSessionEventRequestSchema = z
    .object({
    action: z.enum(UserSessionEventAction),
    formDraftId: z.uuid().optional(),
})
    .strict();
//# sourceMappingURL=userSessionEvent.js.map